module.exports = __webpack_public_path__ + "img/sushi-robots.d4caa9a8.png";